import { EmailThread } from '../models';
import { ModelResource } from './resource';

export class EmailThreads extends ModelResource<EmailThread> {
  model = EmailThread;

  resourcePath = 'v1/email-threads';

  async markAsRead(emailThreadId: string): Promise<void> {
    await this.api.post(`v2/email-threads/${emailThreadId}/read`);
  }
}
